// src/config/index.ts

import { getEnvVariable } from '@config/env';
import { envSchema } from './config.schema';

export function getConfig() {
  const config = envSchema.parse({
    VITE_API_BASE_URL: getEnvVariable('VITE_API_BASE_URL', 'http://localhost'),
    VITE_MSW_BASE_URL: getEnvVariable('VITE_MSW_BASE_URL', 'http://localhost'),
    VITE_DOWNLOAD_LIMIT: getEnvVariable('VITE_DOWNLOAD_LIMIT', '50000'),
    VITE_IS_MSW: getEnvVariable('VITE_IS_MSW', 'true'),
    VITE_AUTH_IS_MSW: getEnvVariable('VITE_AUTH_IS_MSW', 'true'),
    VITE_USER_IS_MSW: getEnvVariable('VITE_USER_IS_MSW', 'true'),
    VITE_CUSTOMER_IS_MSW: getEnvVariable('VITE_CUSTOMER_IS_MSW', 'true'),
    VITE_SOURCES_IS_MSW: getEnvVariable('VITE_SOURCES_IS_MSW', 'true'),
    VITE_FUNDING_IS_MSW: getEnvVariable('VITE_FUNDING_IS_MSW', 'true'),
    VITE_DOCUMENTS_SHOW_ALL: getEnvVariable('VITE_DOCUMENTS_SHOW_ALL', 'false'),
  });

  return config;
}

export const {
  VITE_API_BASE_URL,
  VITE_IS_MSW,
  VITE_DOWNLOAD_LIMIT,
  VITE_MSW_BASE_URL,
  VITE_AUTH_IS_MSW,
  VITE_USER_IS_MSW,
  VITE_CUSTOMER_IS_MSW,
  VITE_SOURCES_IS_MSW,
  VITE_FUNDING_IS_MSW,
  VITE_DOCUMENTS_SHOW_ALL,
} = getConfig();
